<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        [data]="filteredWorkshops"
        (exportar)="onExportar($event)"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="select-cont">
    <label>Localidad</label>
    <select
      [(ngModel)]="selectedZone"
      class="input-field"
      (change)="handleSelectedZoneChange()"
    >
      @for (zone of workShopZones; track $index) {
      <option value="{{ zone }}">{{ zone }}</option>
      }
    </select>
  </div>
</div>

<app-insurance-table
  [itemsPerPage]="7"
  [data]="filteredWorkshops"
  [config]="tableConfig"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
></app-insurance-table>
